import { colorsConfig } from "../../../../../../../config/colors.config";
import { FLOW_HUB_CAROUSEL_ICONS_CONFIG } from "./flowHubCarouselIcons.config";
/**
 * This file is in `.tsx` format because it has React components in it.
 *
 */

export const flowHubCarouselConfig = () => {
  return [
    {
      title: "Transform your workflow",
      header: "Your Digital Concierge for Every Task",
      description:
        "Flow Hub isn't just a management tool; it's an ecosystem designed to guide you through the complexities of modern service delivery. Whether you are hiring or building, we provide the architecture for success.",
      list: [
        {
          title: "Streamlined Quote Requests",
          description: "Professional estimation and proposal management",
          icon: FLOW_HUB_CAROUSEL_ICONS_CONFIG.streamlinedQuoteRequests,
        },
        {
          title: "Dynamic Workforce Management",
          description: "Coordinate teams and contractors with ease.",
          icon: FLOW_HUB_CAROUSEL_ICONS_CONFIG.dynamicWorkforceManagement,
        },
        {
          title: "Integrated Landing Page Design",
          description: "Convert leads with high-performing custom pages.",
          icon: FLOW_HUB_CAROUSEL_ICONS_CONFIG.integratedLandingPageDesign,
        },
      ],
      image: "https://flownect-media-dev.s3.us-west-1.amazonaws.com/images/flowhub-carrousel/your-digital-concierge-for-every-task.png",
      imageFit: "contain",
    },
    {
      title: "Scale with confidence",
      header: "Built for Teams That Mean Business",
      description:
        "Whether you're a solo freelancer or a growing agency, Flow Hub adapts to your scale. Our platform grows alongside your ambitions, giving you the tools to handle more clients without adding complexity.",
      list: [
        {
          title: "Smart Client Management",
          description: "Centralize every client interaction in one place.",
          icon: FLOW_HUB_CAROUSEL_ICONS_CONFIG.smartClientManagement,
        },
        {
          title: "Automated Billing & Invoicing",
          description: "Get paid faster with zero manual effort.",
          icon: FLOW_HUB_CAROUSEL_ICONS_CONFIG.automatedBillingInvoicing,
        },
        {
          title: "Real-Time Analytics Dashboard",
          description: "Make data-driven decisions at a glance.",
          icon: FLOW_HUB_CAROUSEL_ICONS_CONFIG.realTimeAnalyticsDashboard,
        },
      ],
      image: "https://flownect-media-dev.s3.us-west-1.amazonaws.com/images/flowhub-carrousel/built-for-teams-that-mean-business.png",
      imageFit: "contain",
    },
    {
      title: "Collaborate seamlessly",
      header: "One Platform, Every Stakeholder",
      description:
        "Stop juggling tools. Flow Hub brings clients, contractors, and managers into a single collaborative space, reducing friction and keeping every project moving forward without miscommunication.",
      list: [
        {
          title: "Unified Communication Hub",
          description: "Messages, updates, and alerts all in one thread.",
          icon: FLOW_HUB_CAROUSEL_ICONS_CONFIG.unifiedCommunicationHub,
        },
        {
          title: "Role-Based Access Control",
          description: "Grant the right permissions to the right people.",
          icon: FLOW_HUB_CAROUSEL_ICONS_CONFIG.roleBasedAccessControl,
        },
        {
          title: "File & Asset Sharing",
          description: "Securely exchange documents and deliverables.",
          icon: FLOW_HUB_CAROUSEL_ICONS_CONFIG.fileAssetSharing,
        },
      ],
      image: "https://flownect-media-dev.s3.us-west-1.amazonaws.com/images/flowhub-carrousel/one-platform-every-stakeholder.png",
    },
    {
      title: "Deliver on time, every time",
      header: "Project Execution Without the Guesswork",
      description:
        "From kickoff to completion, Flow Hub keeps your projects on track with intelligent scheduling, milestone tracking, and automated reminders that ensure nothing slips through the cracks.",
      list: [
        {
          title: "Milestone & Deadline Tracking",
          description: "Visual timelines that keep every stakeholder aligned.",
          icon: FLOW_HUB_CAROUSEL_ICONS_CONFIG.milestoneDeadlineTracking,
        },
        {
          title: "Automated Status Reminders",
          description: "Proactive nudges before deadlines are missed.",
          icon: FLOW_HUB_CAROUSEL_ICONS_CONFIG.automatedStatusReminders,
        },
        {
          title: "Resource Allocation Planner",
          description: "Assign workloads intelligently across your team.",
          icon: FLOW_HUB_CAROUSEL_ICONS_CONFIG.resourceAllocationPlanner,
        },
      ],
      image: "https://flownect-media-dev.s3.us-west-1.amazonaws.com/images/flowhub-carrousel/project-execution-without-the-guesswork.png",
    },
  ];
};

export const FLOW_HUB_CAROUSEL_ITEM_TITLE_SX_CONFIG = {
  fontSize: { xs: "0.68rem", xl: "0.84rem" },
  fontWeight: 600,
  color: "grey",
  textTransform: "uppercase",
};

export const FLOW_HUB_CAROUSEL_ITEM_HEADER_SX_CONFIG = {
  fontSize: { xs: "1.35rem", xl: "1.75rem" },
  fontWeight: 600,
  color: colorsConfig.textPrimary,
  textTransform: "capitalize",
};

export const FLOW_HUB_CAROUSEL_ITEM_DESCRIPTION_SX_CONFIG = {
  fontSize: { xs: "0.82rem", xl: "1rem" },
  fontWeight: 300,
  color: colorsConfig.textPrimary,
  textTransform: "none",
  width: "100%",
  maxWidth: { xs: "430px", xl: "580px" },
  whiteSpace: "normal",
  overflowWrap: "break-word",
  lineHeight: 1.5,
};
